<template>
  <div class="container">
    <img src="@/assets/images/banner.png" class="banner" />
    <div class="section">
      <p>恭喜您，注册完毕！</p>
      <p>您的申请正在审核中，请您耐心等待~</p>
      <p>预计需要1-2个工作日。</p>
    </div>
    <div class="refresh-btn" @click="toRefresh">刷新状态</div>
  </div>
</template>

<script>
import { getExamineInfo } from '@/api/user';
export default {
  name: 'register-results',
  data () {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: undefined,
    }
  },
  created() {
    this.shopCode = this.$route.query && this.$route.query.shopCode ? this.$route.query.shopCode : undefined;
  },
  methods: {
    toRefresh() {
      //examineStatusCustomer 客服审核状态 0待沟通 1待设置 2沟通不通过 3待签约 4待付款 5待提交资质 6待初审 7初审失败 8 易宝待审核 9易宝审核成功 10 易宝审核失败 
      getExamineInfo(this.shopCode).then(res => {
        if(res.data && res.data.length > 0) {
          let examineStatusCustomer = res.data[0].examineStatusCustomer;
          if(examineStatusCustomer < 3) {
            this.Toast('已刷新状态~');
          } else if(examineStatusCustomer == 3) {
            this.$router.push({
              path: '/apply-package?shopCode=' + this.shopCode
            })
          } else if(examineStatusCustomer == 4) {
            this.$router.push({
              path: '/payment?shopCode=' + this.shopCode
            })
          } else if(examineStatusCustomer == 5) {
            this.$router.push({
              path: '/baseinfo-auth?shopCode=' + this.shopCode
            })
          } else if(examineStatusCustomer == 6 || examineStatusCustomer == 8 || examineStatusCustomer == 10) {
            this.$router.push({
              path: '/apply-results?shopCode=' + this.shopCode
            })
          } else if(examineStatusCustomer == 9) {
            this.$router.push({
              path: '/apply-passed?shopCode=' + this.shopCode
            })
          } else {
            this.Toast('已刷新状态~');
          }
        } else {
          this.Toast('已刷新状态~');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: 1px;
    position: relative;
  }
  .banner{
    width: 16.75rem;
    height: 8.2rem;
    display: block;
    margin: 1.2rem auto 1.2rem;
    border-radius: .8rem;
  }
  .section{
    width: 16.75rem;
    margin: 0 auto;
    p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: .25rem;
    }
  }
  .refresh-btn{
    width: 15rem;
    height: 2.2rem;
    line-height: 2.2rem;
    background: #47B6C7;
    border-radius: .4rem;
    margin: 3rem auto;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
}
@media screen and (min-width:750px){
  .banner{
    width: 335px;
    height: 164px;
    display: block;
    margin: 24px auto 24px;
    border-radius: 16px;
  }
  .section{
    width: 335px;
    margin: 0 auto;
    p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 5px;
    }
  }
  .refresh-btn{
    width: 300px;
    height: 44px;
    line-height: 44px;
    background: #47B6C7;
    border-radius: 8px;
    margin: 60px auto;
    font-size: 16px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/register-results.vue